<script setup>
import { useI18n } from 'vue-i18n';
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inboxName: { type: String, default: '' },
});

const emit = defineEmits(['onConfirm', 'onClose']);
const show = defineModel('show', { type: Boolean, default: false });
const { t } = useI18n();

const close = () => {
  show.value = false;
  emit('onClose');
};
</script>

<template>
  <Modal v-model:show="show" :on-close="close">
    <div class="flex flex-col items-center px-8 pt-8 pb-0 text-center">
      <div
        class="mb-5 flex size-20 items-center justify-center rounded-full bg-n-ruby-3"
      >
        <span class="i-lucide-triangle-alert size-10 text-n-ruby-11" />
      </div>
      <h2 class="text-xl font-bold text-n-slate-12">
        {{ t('INBOX_MGMT.DELETE.FINAL_CONFIRM.TITLE') }}
      </h2>
      <p class="mt-2 text-sm text-n-slate-11">
        {{
          t('INBOX_MGMT.DELETE.FINAL_CONFIRM.SUBTITLE', {
            inboxName: props.inboxName,
          })
        }}
      </p>
    </div>
    <form class="flex flex-col" @submit.prevent="emit('onConfirm')">
      <div
        class="mb-5 rounded-lg border border-n-ruby-6 bg-n-ruby-3 p-4 text-sm text-n-ruby-12"
      >
        <p class="mb-2 font-semibold">
          {{ t('INBOX_MGMT.DELETE.FINAL_CONFIRM.WARNING_TITLE') }}
        </p>
        <ul class="space-y-1.5">
          <li class="flex items-start gap-2">
            <span class="i-lucide-x mt-0.5 size-4 shrink-0 text-n-ruby-11" />
            {{ t('INBOX_MGMT.DELETE.FINAL_CONFIRM.LOSS_1') }}
          </li>
          <li class="flex items-start gap-2">
            <span class="i-lucide-x mt-0.5 size-4 shrink-0 text-n-ruby-11" />
            {{ t('INBOX_MGMT.DELETE.FINAL_CONFIRM.LOSS_2') }}
          </li>
          <li class="flex items-start gap-2">
            <span class="i-lucide-x mt-0.5 size-4 shrink-0 text-n-ruby-11" />
            {{ t('INBOX_MGMT.DELETE.FINAL_CONFIRM.LOSS_3') }}
          </li>
        </ul>
      </div>
      <Button
        ruby
        type="submit"
        :label="t('INBOX_MGMT.DELETE.FINAL_CONFIRM.YES')"
        class="w-full"
      />
      <Button
        slate
        faded
        type="button"
        :label="t('INBOX_MGMT.DELETE.FINAL_CONFIRM.NO')"
        class="mt-2 w-full"
        @click="close"
      />
    </form>
  </Modal>
</template>
